var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.677 10.92a1.1 1.1 0 00-.624-1.87l-7.75-1.064L14 .647a1.094 1.094 0 00-1.998 0L8.697 7.986.947 9.05a1.1 1.1 0 00-.624 1.87l5.714 5.704-1.432 8.083a1.097 1.097 0 001.624 1.146L13 21.962l6.77 3.893a1.097 1.097 0 001.625-1.147l-1.432-8.084 5.714-5.704zm-22.658-.135l5.17 5.161-1.278 7.21 6.09-3.501 6.088 3.5-1.277-7.21 5.17-5.16-7.047-.968L13 3.3l-2.934 6.516-7.047.969z",
    fill: "#CCC"
  })));
}

export default SvgIconStarEmpty;